import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import 'datatables.net'; // Import DataTables
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import { storage, ref, uploadBytesResumable, getDownloadURL, db, collection, addDoc, doc, getDoc, setDoc, getDocs, deleteDoc, updateDoc, writeBatch, query, where } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import EditSoal from './form/EditSoal';
import Maping from "./form/Maping.js";
import Swal from "sweetalert2";
import Compressor from 'compressorjs';
import { useAuth } from '../../context/AuthContext.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Modal from "react-modal";
import Editor from "./form/Editor";


import Jawaban from './form/Jawaban.js';
const ViewEvaluasi = () => {
    const { user, loading, logout } = useAuth();
    const [data, setData] = useState([]); // State untuk menyimpan daftar kelas
    const location = useLocation(); // Gunakan useLocation untuk membaca query string
    const queryParams = new URLSearchParams(location.search);
    const id_ujian = queryParams.get('id_ujian');

    const [editors, setEditors] = useState(["text-editor"]);
    const navigate = useNavigate();

    const [soalmap, setSoalmap] = useState([]);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [loadngloadData, setIsloadngloadData] = useState(false);
    const [poin, setPoin] = useState(1);
    const [isEdit, setisEdit] = useState(false);
const [totalpoin, setTotalPoin] = useState(1);
    const didMount = useRef(false);
    const [selectedSoal, setSelectedSoal] = useState(null);
    const [gform, setGform] = useState([]);

    const [soalGformPilih, setSoalGformPilih] = useState([]);
    const [soallis, setSoalList] = useState([]);
    const [soallisid, setSoalListId] = useState([]);

    const [fetchTrigger, setFetchTrigger] = useState(0); // State pemicu fetch ulang

    const [isOpenMaping, setIsOpenMaping] = useState(false);
    const [jawaban, setJawaban] = useState([]);
    const [jenis, setJenis] = useState("");
    const [soal, setSoal] = useState("");
    const [cleanTrigger, setCleanTrigger] = useState(1);


    const bukaModalmaping = () => {
        setIsOpenMaping(true);
    };

    const tutupModalmaping = () => {
        setIsOpenMaping(false);
    };
    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Transparan
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        color: "#fff",
        fontSize: "20px",
    };




    const fetchKelas = async () => {
        setIsloadngloadData(true)
        setSoalList([]);

        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/viewevaluasi?id_ujian=${id_ujian}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            console.log(data)

            // Menyimpan data kelas ke dalam state
            setData(data.data);
            let soalid = []
            if (data.data.soal) {
                soalid = JSON.parse(data.data.soal)
            }
            setSoalListId(soalid)
            const results = await getDocumentsByIds(soalid);
            results.sort((a, b) => {
                return (a.id_soal || 0) - (b.id_soal || 0);
            });
            // Simpan daftar soal ke state
            setSoalList(results);
            setIsloadngloadData(false)
        } catch (error) {
            setIsloadngloadData(false)

        }
        setIsloadngloadData(false)
    };



    const getDocumentsByIds = async (documentIds) => {
        try {
            let documents = [];

            // Memecah array ID menjadi kelompok maksimal 30
            const chunkSize = 30;
            for (let i = 0; i < documentIds.length; i += chunkSize) {
                const chunk = documentIds.slice(i, i + chunkSize); // Ambil maksimal 30 ID

                const colRef = collection(db, "soal"); // Ganti dengan nama koleksi Firestore
                const q = query(colRef, where("__name__", "in", chunk)); // "__name__" adalah ID dokumen
                const querySnapshot = await getDocs(q);

              let total = 0;

querySnapshot.docs.forEach((doc) => {
  const data = doc.data();

  documents.push({
    id: doc.id,
    ...data,
  });

  total += data.poin || 0;
});

setTotalPoin(total);
            }
            return documents;
        } catch (error) {
            console.error("Error mengambil data:", error);
            return [];
        }
    };




    const handleSoalMapCheckboxChange = (id) => {
        setSoalmap(prev => {
            if (prev.includes(id)) {
                return prev.filter(item => item !== id); // Hapus jika sudah dipilih
            } else {
                return [...prev, id]; // Tambahkan jika belum dipilih
            }
        });
    };



    const handleSaveSoal = async () => {

        if (isLoadingSave) return;
        setIsLoadingSave(true);

        let soalText = soal;

        if (!soalText.trim()) {
            Swal.fire("Peringatan!", "Soal atau Jawaban tidak boleh kosong!", "warning");
            setIsLoadingSave(false);
            return;
        }

        const newSoal = {
            poin,
            npsn: user.npsn,
            guru_id: user.data_id,
            id_mapel: data.id_mapel,
            id_rombel: data.id_rombel,
            pembelajaran_id: data.pembelajaran_id,
            nama_rombel: data.nama_rombel,
            soal: soalText,
            jenis,
            jawaban
        };

        try {

            let soalId = selectedSoal?.id;

            // =====================
            // MODE UPDATE
            // =====================
            if (soalId) {
                const soalRef = doc(db, "soal", soalId);

                await updateDoc(soalRef, newSoal);

                Swal.fire("Berhasil!", "Soal berhasil diperbarui", "success");
                setisEdit(false)
   setCleanTrigger(cleanTrigger+1);
                // update list lokal
                setSoalList(prev =>
                    prev.map(item =>
                        item.id === soalId ? { ...item, ...newSoal } : item
                    )
                );
            }

            // =====================
            // MODE CREATE
            // =====================
            else {
                const soalCreate = {
                    ...newSoal,
                    id_soal: soallis.length + 1
                };

                const docRef = await addDoc(collection(db, "soal"), soalCreate);
                soalId = docRef.id;

                await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/updateujiansoal`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify({
                        id_ujian,
                        soal: JSON.stringify([...soallisid, soalId])
                    }),
                });

                setSoalListId(prev => [...prev, soalId]);

                const results = await getDocumentsByIds([soalId]);
                setSoalList(prev => [...prev, results[0]]);

                Swal.fire("Berhasil!", "Soal berhasil ditambahkan", "success");
            }

            // =====================
            // RESET FORM
            // =====================
            setCleanTrigger(cleanTrigger+1);
            setSelectedSoal(null);

            setTimeout(() => {
                document.getElementById("baru")
                    ?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 500);

        } catch (error) {
            console.error("Error saat menyimpan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan soal", "error");
        } finally {
            setIsLoadingSave(false);
        }
    };



    const handleMaping = async (pembelajaranparm) => {
        if (!soalmap || soalmap.length === 0) {
            Toastify({
                text: "Soal belum ada yg dipilih",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "red",
            }).showToast();
            return;
        }


        if (!pembelajaranparm) {
            Toastify({
                text: "Pilih 1 atau lebih pembelajaran",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "red",
            }).showToast();
            return;
        }

        try {
            const batch = writeBatch(db);

            for (const idp of pembelajaranparm) {
                for (const soal of soalmap) {
                    const soalRef = doc(db, `ujian/${idp}/soal`, soal.id);
                    batch.set(soalRef, {
                        soalId: soal.id,
                        urutan: soal.urutan || Date.now(), // Gunakan urutan dari soalMap jika ada, jika tidak pakai timestamp
                    });
                }
            }

            await batch.commit(); // Eksekusi semua perubahan dalam satu transaksi

            console.log("Referensi soal berhasil ditambahkan ke ujian dengan ID:", pembelajaranparm);

            Toastify({
                text: "Soal berhasil dimapping!",
                duration: 3000,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#4CAF50",
            }).showToast();

        } catch (error) {
            console.error("Error:", error);
            alert("Terjadi kesalahan saat menyimpan soal");
        }
    };


    const handleEditClick = ((soal, id) => {
        setisEdit(true)
        setSelectedSoal(soal);
        setTimeout(() => {
            // Scroll ke data yang baru ditambahkan (dengan ID yang sesuai)
            let newDataElement = document.getElementById(id);
            if (newDataElement) {
                newDataElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 200);
    });


    const handleHapusSoal = async (idSoal) => {
        const result = await Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Soal ini akan dihapus dari daftar ujian ini, soal ini tidak dihapus dari daftar ujian yg lain jika telah di maping!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
            reverseButtons: true, // Membalik tombol OK & Batal untuk UX yang lebih baik
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/updateujiansoal`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify({
                        id_ujian,
                        soal: JSON.stringify(soallisid.filter(id => id !== idSoal))
                    }),
                });

                if (!response.ok) {
                    throw new Error("Gagal menyimpan data ke server");
                }

                const result = await response.json();
                Swal.fire({
                    title: "Berhasil!",
                    text: result.message,
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                });
                setSoalListId(prevSoallis => prevSoallis.filter(id => id !== idSoal));
                setSoalList(prevSoalList => prevSoalList.filter(soal => soal.id !== idSoal));

            } catch (error) {
                console.error("Error:", error);
                Swal.fire({
                    title: "Gagal!",
                    text: "Terjadi kesalahan saat menghapus soal.",
                    icon: "error",
                    confirmButtonColor: "#d33",
                });
            }
        }
    };




   const ganrateGform = async () => {
  setIsloadngloadData(true);
  const urlGform = document.getElementById("gformurl").value;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/pendidik/get-form-data`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          urlgform: urlGform,
          guru_id: user.data_id,
          id_mapel: data.id_mapel,
          id_rombel: data.id_rombel,
          pembelajaran_id: data.pembelajaran_id,
          nama_rombel: data.nama_rombel,
          nama_mapel: data.nama_mapel,
        }),
      }
    );

    if (!response.ok) throw new Error("Gagal mengambil soal");

    const result = await response.json();

    // ⬅️ PENTING
    setGform(result.data);

  } catch (error) {
    console.error(error);
    alert("Terjadi kesalahan saat mengambil soal");
  } finally {
    setIsloadngloadData(false);
  }
};

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSoalGformPilih([...gform]); // Centang semua item dengan duplikasi array
        } else {
            setSoalGformPilih([]); // Hapus semua centang
        }
    };
    const handleSelectAllForMaping = (event) => {

        if (event.target.checked) {
            setSoalmap([...soallis]); // Centang semua item dengan duplikasi array
        } else {
            setSoalmap([]); // Hapus semua centang
        }
    };

    const handleItemChange = (item) => {
        setSoalGformPilih((prevData) => {
            const exists = prevData.some((i) => i.id_soal === item.id_soal);

            if (exists) {
                return prevData.filter((i) => i.id_soal !== item.id_soal);
            } else {
                return [...prevData, { ...item }]; // Pastikan objek baru untuk memicu re-render
            }
        });
    };

    const handleSave = async () => {
        setIsLoadingSave(true);

        Swal.fire({
            title: 'Menyimpan Soal...',
            html: 'Mohon tunggu sebentar',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        try {

            // =====================
            // MODE UPDATE
            // =====================
            if (selectedSoal?.id) {
                const soalRef = doc(db, "soal", selectedSoal.id);

                await updateDoc(soalRef, {
                    ...selectedSoal,
                });

                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Soal berhasil diperbarui',
                    timer: 2500,
                    showConfirmButton: false
                });
            }

            // =====================
            // MODE CREATE (BATCH)
            // =====================
            else {
                const soalin = [];
                const batch = writeBatch(db);
                const quizCollection = collection(db, "soal");

                for (const soal of soalGformPilih) {
                    const docRef = doc(quizCollection);
                    soalin.push(docRef.id);

                    batch.set(docRef, {
                        ...soal,

                    });
                }

                await batch.commit();

                await fetch(
                    `${process.env.REACT_APP_BASE_URL}/pendidik/updateujiansoal`,
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: JSON.stringify({
                            id_ujian,
                            soal: JSON.stringify(soalin)
                        }),
                    }
                );

                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: 'Semua Soal Dipilih Berhasil Disimpan',
                    timer: 3000,
                    showConfirmButton: false
                });
            }

            setFetchTrigger(prev => prev + 1);

        } catch (error) {
            console.error("Error menyimpan soal:", error);

            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Gagal',
                text: 'Terjadi kesalahan saat menyimpan soal.',
            });
        } finally {
            setIsLoadingSave(false);
        }
    };

    const handleCheckboxChangeGForm = (idSoal, idJwb) => (e) => {
        const isChecked = e.target.checked ? 1 : 0;

        setSoalGformPilih((prevData) =>
            prevData.map((item) =>
                item.id_soal === idSoal
                    ? {
                        ...item,
                        jawaban: item.jawaban.map((item2) =>
                            item2.id_jwb === idJwb ? { ...item2, kunci: isChecked } : item2
                        ),
                    }
                    : item
            )
        );
    };

    useEffect(() => {

        fetchKelas();
        didMount.current = true; // Menandai bahwa fungsi sudah dieksekusi

    }, []);


    useEffect(() => {
        fetchKelas();
    }, [fetchTrigger]);
    return (
        <>
            {loadngloadData && (
                <div style={overlayStyle}>
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row d-flex flex-wrap" >
                        <div className="col-xl-12 col-md-12" >
                            <div className="card">
                                <div className="card-header">
                                    <h5>Daftar Ujian</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row g-4">
                                        <div className="col-md-4">
                                            <h5>Pendidik</h5>
                                            <hr />
                                            <h5>{data.nama_guru}</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <h5>Kelas</h5>
                                            <hr />
                                            <h5>{data.nama_rombel}</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <h5>Pelajaran</h5>
                                            <hr />
                                            <h5>{data.nama_mapel}</h5>
                                        </div>
                                    </div>
                                    <hr />
                                    <a href='#baru' className="btn btn-labeled btn-success text-white d-inline-flex"> <span className="btn-label"><i className='ti ti-plus'></i> </span>Soal baru</a>

                                    {/* <button type="button" className="btn btn-danger d-inline-flex" onClick={bukaModalmaping}><i className='ti ti-arrows-split'></i> Maping Soal</button> */}
                                    <button type="button" className="btn btn-labeled btn-secondary text-white d-inline-flex" data-bs-toggle="modal" data-bs-target="#modalgoogleform"><span className="btn-label"><i className='ti ti-arrows-split'></i></span> Salin Dari Google Formulir</button>


                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-xl-12 d-flex mb-3">
                            <div className="card w-100">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between  row ">
                                        <div className="form-check form-check-inline col">
                                            <input className="form-check-input" id="customCheckinlh3"
                                                type="checkbox"
                                                onChange={handleSelectAllForMaping}

                                            />
                                            <label className="form-check-label" htmlFor="customCheckinlh3">Pilih Semua</label>
                                        </div>
                                        <div className='col-auto'>
                                            Total Poin : {totalpoin}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {soallis.map((soal, index) => (
                            selectedSoal && selectedSoal.id === soal.id ? (
                                <div className='row'>

                                    <div className="col-sm-12 col-md-12 col-xl-12" id='baru'>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row justify-content-between align-items-center"><h4 className='col'>Edit Soal</h4>

                                                    <div className='row col-auto '>
                                                        <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                                            <input
                                                                type="number"
                                                                id="poin"
                                                                className="form-control"
                                                                placeholder="Poin"
                                                                value={poin}
                                                                onChange={(e) => setPoin(Math.max(1, Number(e.target.value)))}
                                                                min="1"
                                                            />
                                                        </div>
                                                        <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                                            <button
                                                                className="col-auto btn btn-primary"
                                                                type="button"
                                                                onClick={handleSaveSoal}
                                                                disabled={isLoadingSave}>
                                                                <i className="ti ti-file-symlink"></i>
                                                                {isLoadingSave ? (
                                                                    <>
                                                                        <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                                        Loading...
                                                                    </>
                                                                ) : (
                                                                    "Ubah"
                                                                )}
                                                            </button>
                                                              <button
                                                                className="col-auto btn btn-primary"
                                                                type="button"
                                                                onClick={()=>{
                                                                    setSelectedSoal(null)
                                                                }}>
                                                                <i className="ti ti-file-symlink"></i>
                                                                Batal
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                <Editor clean={cleanTrigger} value={soal.soal} user={useAuth} onChange={(e) => {

                                                    setSoal(e)

                                                }} />
                                                <hr />
                                                <Jawaban value={soal.jawaban} jenised={soal.jenis} clean={cleanTrigger} onChange={(e) => {

                                                
                                                  
                                                    setJenis(e.jenis)
                                                    setJawaban(e.jawaban)


                                                }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ) : (
                                <div key={soal.id} id={"heade" + soal.id} className="col-sm-12 col-md-12 col-xl-12 d-flex mb-3">
                                    <div className="card w-100 d-flex flex-column">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-3 row">
                                                <div className="form-check form-check-inline col">
                                                    <input
                                                        className="form-check-input"
                                                        id={"customCheck" + soal.id} // ID unik untuk setiap checkbox
                                                        value={soal.id}
                                                        onChange={() => handleSoalMapCheckboxChange(soal.id)}
                                                        type="checkbox"
                                                        checked={soalmap.some((i) => i.id_soal === soal.id_soal)}
                                                    />
                                                    <label className="form-check-label" htmlFor={"customCheck" + soal.id}>
                                                        NO : {index + 1}
                                                    </label>
                                                </div>
                                                <div className="col-auto d-flex align-items-center gap-2">
    
    <button
        type="button"
        className="btn btn-sm btn-primary"
       
    >
        Poin : {soal.poin}
    </button>

    <button
        type="button"
        className="btn btn-sm btn-warning"
        onClick={() => handleEditClick(soal, soal.id)}
    >
        Ubah
    </button>

    <button
        type="button"
        className="btn btn-sm btn-danger"
        onClick={() => handleHapusSoal(soal.id)}
    >
        Hapus
    </button>
</div>

                                                
                                            </div>
                                            <hr />
                                            <SoalCard key={soal.id} soal={soal} />
                                         
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}


                        {/* Modal Edit Soal */}

<div className="col-sm-12 col-md-12"  >
<hr></hr>
                        </div>
                       <div className="col-sm-12 col-md-12 col-xl-12" id='baru'>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row justify-content-between align-items-center"><h4 className='col'>Soal Baru</h4>

                                        <div className='row col-auto '>
                                            <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                                <input
                                                    type="number"
                                                    id="poin"
                                                    className="form-control"
                                                    placeholder="Poin"
                                                    value={poin}
                                                    onChange={(e) => setPoin(Math.max(1, Number(e.target.value)))}
                                                    min="1"
                                                />
                                            </div>
                                            <div className="col-sm-6 col-md-6 col-xl-6" id='baru'>
                                                <button
                                                    className="col-auto btn btn-primary"
                                                    type="button"
                                                    onClick={handleSaveSoal}
                                                    disabled={isLoadingSave ||isEdit }>
                                                    <i className="ti ti-file-symlink"></i>
                                                    {isLoadingSave ? (
                                                        <>
                                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                            Loading...
                                                        </>
                                                    ) : (
                                                        "Simpan"
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row g-4">
                                        <div className="col-md-12">

                                            <Editor clean={cleanTrigger} user={useAuth} onChange={(e) => {
                                              
                                                setSoal(e)

                                            }} />
                                            <hr />
                                            <Jawaban clean={cleanTrigger} onChange={(e) => {
                                                setJenis(e.jenis)
                                                setJawaban(e.jawaban)
                                               

                                            }} />
                                        </div>


                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className="row justify-content-between align-items-center"><h5 className='col'>Tindakan</h5>

                                        <button
                                            className="col-auto btn btn-primary"
                                            type="button"
                                            onClick={handleSaveSoal}
                                            disabled={isLoadingSave ||isEdit}>
                                            <i className="ti ti-file-symlink"></i>
                                            {isLoadingSave ? (
                                                <>
                                                    <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                    Loading...
                                                </>
                                            ) : (
                                                "Simpan"
                                            )}
                                        </button>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-12"  >

                        </div>
                    </div>
                </div>
            </div>

            <>
                <Modal
                    isOpen={isOpenMaping}
                    onRequestClose={tutupModalmaping}
                    contentLabel="Maping Soal Modal"
                    style={{
                        overlay: {
                            backgroundColor: "rgba(0,0,0,0.5)",
                            zIndex: 9999,
                        },
                        content: {
                            width: "800px",
                            maxWidth: "90%",
                            margin: "auto",
                            borderRadius: "10px",
                            padding: "0",
                            inset: "50px auto auto auto",
                        },
                    }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Maping Soal</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={tutupModalmaping}
                            ></button>
                        </div>

                        <div className="modal-body">
                            <Maping onSave={handleMaping} soal={soalmap} data={[]} />
                        </div>
                    </div>
                </Modal>
            </>


            <div className="modal fade" id="modalgoogleform" >
                <div className="modal-dialog  modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Maping Soal</h5>
                            <button type="button" className="btn-close" id='btn-closemaping' data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label">Link Google Formulir</label>
                                    <div className="input-group">
                                        <input id='gformurl' type="text" className="form-control" placeholder="Url" />
                                        <button className="btn btn-outline-secondary" onClick={ganrateGform} type="button">Ganrate Soal</button>
                                    </div>

                                </div>
                            </form>

                            <div className="p-4">
                                {/* Checkbox Pilih Semua */}
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        className="form-checkbox"
                                        checked={soalGformPilih.length === gform.length}
                                        onChange={handleSelectAll}
                                    />
                                    <span>Pilih Semua</span>
                                </label>
                            </div>

                            <div className="mt-2 space-y-2">
                                {gform.map((item, index2) => (
                                    <div className="list-group" key={index2}>
                                        <label className="list-group-item">
                                            <input
                                                type="checkbox"
                                                className="form-check-input me-1"
                                                checked={soalGformPilih.some((i) => i.id_soal === item.id_soal)}
                                                onChange={() => handleItemChange(item)}
                                            />
                                            <span dangerouslySetInnerHTML={{ __html: item.soal }}></span>
                                            <b>{item.jenis}</b>
                                            <ul className="list-group">
                                                {item?.jawaban?.map((item2, index) => (
                                                    <li className="list-group-item" key={`${item.id_soal}-${item2.id_jwb}`}>
                                                        <label className="list-group-item">
                                                            <input
                                                                className="form-check-input me-1"
                                                                type="checkbox"

                                                                onChange={handleCheckboxChangeGForm(item.id_soal, item2.id_jwb)}
                                                            />
                                                            <span dangerouslySetInnerHTML={{ __html: item2.text }}></span>
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" onClick={handleSave} className="btn btn-primary">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
const SoalCard = (({ soal }) => {
    const jenisLabel = {
        objectif: "Objektif",
        ganda: "Ceklis",
        essay: "Esai",
        cj: "Cocokkan",
        bs: "Benar Salah"
    };

    return (<div>
        {/* {parse(soal.soal)} */}
        <div key={"soaltext" + soal.id} dangerouslySetInnerHTML={{ __html: soal.soal }} />
        <hr />
        <b>Jawaban <span style={{ color: '#9e2709' }}>{jenisLabel[soal.jenis] ?? "Pilih Jenis Jawaban"}</span></b>
        <br /><br />
        {soal.jenis === "ganda" ? (
            <table className='table table-hover table-bordered' >
                <thead>
                    <tr>
                        <th width="50">Kunci</th>
                        <th>Text</th>
                    </tr>
                </thead>
                <tbody>
                    {soal.jawaban?.map((jawaban, index) => (
                        <tr key={`jwb${index}`}>
                            <th><input disabled className="form-check-input input-success" type="checkbox" defaultChecked={jawaban.kunci === 1} /></th>
                            <th><div dangerouslySetInnerHTML={{ __html: jawaban.text }} /></th>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : soal.jenis === "objectif" ? (
            <table className='table table-hover table-bordered'>
                <thead>
                    <tr>
                        <th width="50">Kunci</th>
                        <th>Text</th>
                    </tr>
                </thead>
                <tbody>
                    {soal.jawaban?.map((jawaban, index) => (
                        <tr key={`jwb1${index}`}>
                            <th><input disabled className="form-check-input input-success" type="radio" defaultChecked={jawaban.kunci === 1} /></th>
                            <th><div dangerouslySetInnerHTML={{ __html: jawaban.text }} /></th>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : soal.jenis === "bs" ? (
            <table className='table table-hover table-bordered' >
                <thead>
                    <tr>
                        <th width="50">Benar</th>
                        <th width="50">Salah</th>
                        <th>Text</th>
                    </tr>
                </thead>
                <tbody>
                    {soal.jawaban?.map((jawaban, index) => (
                        <tr>
                            <th><input disabled className="form-check-input input-success" type="radio" defaultChecked={jawaban.kunci === 1} /></th>
                            <th><input disabled className="form-check-input input-success" type="radio" defaultChecked={jawaban.kunci === 0} /></th>
                            <th><div dangerouslySetInnerHTML={{ __html: jawaban.text }} /></th>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : soal.jenis === "cj" ? (
            <table className='table table-hover table-bordered' >
                <thead>
                    <tr>
                        <th width="50">Text</th>
                        <th width="50">Cocok</th>
                    </tr>
                </thead>
                <tbody>
                    {soal.jawaban?.map((jawaban, index) => (
                        <tr>

                            <th><div dangerouslySetInnerHTML={{ __html: jawaban.text }} /></th>
                            <th><div dangerouslySetInnerHTML={{ __html: jawaban.text2 }} /></th>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : soal.jenis === "essay" ? (
            <>{soal.jawaban?.map((jawaban, index) => (<div dangerouslySetInnerHTML={{ __html: jawaban.text }} />))}</>
        ) : (<></>)}

    </div>

    );
});
export default ViewEvaluasi;
